import { render } from "./TypingDotsComponent.vue?vue&type=template&id=4864bc4e&scoped=true"
const script = {}

import "./TypingDotsComponent.vue?vue&type=style&index=0&id=4864bc4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4864bc4e"]])

export default __exports__